import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getShiftRotation = async ({
  companyCode,
  locationCode,
  employeeCode,
  fromDate,
  toDate,
  groupCode,
  shiftCode,
}) => {
  let queryString = "";

  if (groupCode === 0) {
    queryString += `&Group=${groupCode}`;
  }

  if (shiftCode === 0) {
    queryString += `&shift=${shiftCode}`;
  }

  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetShiftRotation}?Employeecode=${employeeCode}&companyCode=${companyCode}&LocationCode=${locationCode}${queryString}`
  );
  // &FromDate=${fromDate}&Todate=${toDate}
  return data;
};

const shiftRotationCreation = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.ShiftRotationCreation,
    input
  );
  return data;
};

export const useGetShiftRotationQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetShiftRotation],
    queryFn: () => getShiftRotation(input),
  });
};

export const useShiftRotationCreationMutation = () => {
  return useMutation({
    mutationFn: shiftRotationCreation,
  });
};
